export function formatQuantity(v: number): string {
    const formatter = new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    return formatter.format(v);
}

export function formatPercent(v: number): string {
    const formatter = new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    return formatter.format(v);
}